// Case form field constants
export const TITLE = 'Title';
export const DESCRIPTION = 'Description';
export const STATUS_ID = 'StatusId';
export const STATUS_TITLE = 'StatusTitle';
export const CUSTOMER_ID = 'CustomerId';
export const CUSTOMER_NAME = 'CustomerName';
export const CONSULTANT_CONTACT_ID = 'ConsultantContactId';
export const CONSULTANT_NAME = 'ConsultantName';
export const PRIMARY_CONTACT_ID = 'PrimaryContactId';
export const PRIMARY_CONTACT_NAME = 'PrimaryContactName';
export const GROUP_ID = 'GroupId';
export const GROUP_TITLE = 'GroupTitle';
export const PROJECT_ID = 'ProjectId';
export const PROJECT_TITLE = 'ProjectTitle';
export const DELIVERABLE_ID = 'DeliverableId';
export const DELIVERABLE_TITLE = 'DeliverableTitle';
export const PRIVATE = 'Private';
export const IP_RESTRICTED = 'IpRestricted';

// Pagination
export const INITIAL_VISIBLE_COUNT = 50;
export const LOAD_MORE_COUNT = 50;
export const SCROLL_THRESHOLD = 100;
